<template>
  <div>
    <Main/>
  </div>
</template>

<script>
import Main from "../../bosques/casas/mapLocation/Main.vue";

export default {
  name: "MenuBosques",
  components: {
    Main,
  },
};
</script>
